import { api } from './client';

const sent = new Set<string>();

/**
 * Brauzer xatosini adminlarga yuborish (Telegram, server tomonda throttle/redact/dedupe).
 * Xato hisobotining o'zi hech qachon yangi xato keltirib chiqarmaydi; bir sessiyada bir xil xabar — bir marta.
 */
export function reportClientError(app: 'miniapp' | 'web', error: unknown) {
  try {
    const err = error instanceof Error ? error : new Error(String(error));
    const message = `${err.name}: ${err.message}`.slice(0, 1000);
    if (sent.has(message)) return;
    sent.add(message);
    void api('/public/client-errors', {
      method: 'POST',
      body: {
        app,
        message,
        url: typeof location === 'undefined' ? undefined : location.pathname.slice(0, 300),
        stack: err.stack?.slice(0, 2000),
      },
    }).catch(() => undefined);
  } catch {
    // Hisobot yuborilmasa ham — jim.
  }
}
